import { typeCreatorV2 } from 'redux/utils/common';

//  [REDUCER][TYPE]
export const SET_FAVORITES: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetFavoritesData'
);

export const SET_ALL_PROPERTIES_COLLECTION: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetAllPropertiesCollection'
);

export const SET_PROPERTY_ONE_COLLECTION: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetPropertiesOneCollection'
);

export const SET_PROPERTY_COLLECTIONS: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetPropertyCollections'
);

export const DELETE_ACCOUNT_COLLECTION: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'DeletePropertyCollections'
);

export const CLIENT_ACCOUNT_SHARE_COLLECTIONS: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'ShareCollections'
);
export const SET_CUSTOMERS: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetCustomer'
);

export const REMOVE_FROM_FAVOURITE: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetCustomer'
);

export const SEND_EMAIL_PRODUCT: string = typeCreatorV2(
  'ClientSavedSearchesReducer',
  'SetSendEmailProduct'
);
